import { render } from "./AdicionalSection.vue?vue&type=template&id=808181ae&ts=true"
import script from "./AdicionalSection.vue?vue&type=script&lang=ts"
export * from "./AdicionalSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__